<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Expense {{GetID == 1?'Approval':'Request'}}
            </div>
            <div class="col-auto">
                <span class="badge"
                    [ngClass]="{'success': common.ToLowerCase(DetailData.ApprovalStatus) == 'approved', 'danger':common.ToLowerCase(DetailData.ApprovalStatus) == 'rejected','warning':common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' || common.ToLowerCase(DetailData.ApprovalStatus) == 'reInitiated' || common.ToLowerCase(DetailData.ApprovalStatus) == 'pendingwithsenior'}">{{DetailData.ApprovalStatus}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body p-1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-2">
                                        <img *ngIf="DetailData.Photo != null && DetailData.Photo != ''" mat-card-image
                                            class="userImage" [src]="common.PhotoLink(DetailData.Photo)" />
                                        <div *ngIf="DetailData.Photo == null || DetailData.Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(DetailData.EmployeeName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.EmployeeName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.EmpCode}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{DetailData.DesignationName}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                            <div class="col-auto text-end">
                                <label for="RequestDate" class="text-label-light">Request Date</label> <br />
                                <label name="RequestDate" class="text-label-dark">{{DetailData.RequestDate}}</label>
                            </div>
                        </div>

                        <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Trip
                                        Name</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.TripName}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">From
                                        Date</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.FromDate}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">To
                                        Date</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ToDate}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Advance
                                        Amount</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.AdvanceAmount}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Approved
                                        Amount</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" placeholder="Ex. 15000"
                                        name="ApprovedAmount" [(ngModel)]="DetailData.ApprovedAmount"
                                        #ApprovedAmount="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(DetailData.ApprovedAmount))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(DetailData.ApprovedAmount))"
                                        style="padding: 0 0.4rem;" required [disabled]="this.GetID == 2">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Description</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.Description}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 ps-1">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 p-0">
                            <div class="card">
                                <label class="m-2" *ngIf="!isApprovalLavel">{{tooltip.NoApprovalLevel}}</label>
                                <div class="card-body" *ngIf="isApprovalLavel">
                                    <div id="content">
                                        <ul class="timeline">
                                            <li class="event p-0 m-0" *ngFor="let Tracking of TrackingsUser">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3 class="m-0">
                                                            {{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                                <input type="text" class="form-control" placeholder="Remark" id="Remark"
                                                    name="Remark" [(ngModel)]="Filter.Remark" #Remark="ngModel"
                                                    [ngClass]="{'is-invalid': this.Filter.isShowError}"
                                                    (change)="removeError()"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1">

                                                <div class="invalid-feedback"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1 && this.Filter.isShowError">
                                                    Please Enter Remark!
                                                </div>
                                                <hr />
                                            </li>
                                            <li class="event p-0 m-0" *ngFor="let Tracking of Trackings">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3>{{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                            </li>
                                            <li class="event p-0 m-0">
                                                <div class="row">
                                                    <h3>Submitted on</h3>
                                                </div>
                                                <label class="date">{{DetailData.RequestDate}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Cancel()"><i
                    class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
            <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                class="btn btn-danger" [disabled]="isDisabled" (click)="ApprovalMatrixRequestProcess('Reject')"><i
                    class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Reject':'Loading...'}}</button>

            <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                class="btn btn-success" [disabled]="isDisabled" (click)="ApprovalMatrixRequestProcess('Approve')"><i
                    class="bi bi-check2" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Approve':'Loading...'}}</button>
        </div>
    </div>
</div>